// @archigraph 7qseDRed
// @archigraph kucCWGUQ
// Download page for archigraph.ai

import { useState } from 'react';
import { Container } from '../components/ui/Container';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

const CURRENT_VERSION = '0.1.0';
const DMG_URL = 'https://archigraph.ai/releases/0.1.0/ArchiGraph-0.1.0-arm64.dmg';
const DMG_SIZE_MB = 145;

// @archigraph triggers|ui.website.download|interface.download.releases|api (IMIlKXn7)
// @archigraph triggers|ui.website.download|interface.download.url|api (fCN22XyO)

export function DownloadPage() {
  const [expandedInstall, setExpandedInstall] = useState(false);

  return (
    <div className="py-16">
      <Container>
        {/* Hero */}
        <div className="mb-16">
          <p className="text-xs uppercase tracking-widest text-primary mb-4 font-bold">
            // download
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-text mb-2">
            Get ArchiGraph
          </h1>
          <p className="text-sm text-text-lighter">
            v{CURRENT_VERSION} &middot; macOS &middot; Auto-updates included
          </p>
        </div>

        {/* Download Card */}
        <div className="max-w-md mb-16">
          <Card padding="lg" className="flex flex-col">
            <div className="flex items-baseline justify-between mb-4">
              <h2 className="text-sm font-bold text-text uppercase tracking-wider">macOS</h2>
              <span className="text-[10px] text-primary uppercase tracking-widest">v{CURRENT_VERSION}</span>
            </div>

            <div className="text-[10px] text-text-lighter uppercase tracking-widest space-y-1 mb-6">
              <p>macOS 11+ &middot; Apple Silicon &middot; {DMG_SIZE_MB} MB</p>
            </div>

            <div className="mt-auto">
              <a href={DMG_URL} download>
                <Button variant="primary" size="md" className="w-full">
                  Download .dmg
                </Button>
              </a>
            </div>
          </Card>
        </div>

        {/* Release Notes */}
        <div className="border border-border bg-bg-white p-8 mb-16">
          <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-4">
            Changelog &middot; v{CURRENT_VERSION}
          </h2>
          <ul className="space-y-2">
            {[
              'Initial public release',
              'Visual graph editor with drag-and-drop',
              'Export architecture to YAML',
              'Auto-layout (hierarchical + force-directed)',
              'Auto-update support',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3 text-xs text-text-light">
                <span className="text-primary mt-0.5">+</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Installation Instructions (collapsible) */}
        <div className="border border-border bg-bg-white mb-16">
          <button
            onClick={() => setExpandedInstall(!expandedInstall)}
            className="w-full flex items-center justify-between text-left p-6"
          >
            <h2 className="text-sm font-bold text-text uppercase tracking-wider">Installation</h2>
            <span className={`text-text-lighter text-xs transition-transform ${expandedInstall ? 'rotate-180' : ''}`}>
              {expandedInstall ? '\u2212' : '+'}
            </span>
          </button>
          {expandedInstall && (
            <div className="px-6 pb-6 border-t border-border pt-4">
              <h3 className="text-xs font-bold text-text uppercase tracking-wider mb-1">macOS</h3>
              <p className="text-xs text-text-lighter">Open the .dmg and drag ArchiGraph to Applications.</p>
            </div>
          )}
        </div>

        {/* Auto-Update */}
        <div className="border-l-2 border-primary pl-6">
          <h2 className="text-sm font-bold text-text uppercase tracking-wider mb-2">Auto-updates</h2>
          <p className="text-xs text-text-lighter leading-relaxed max-w-xl">
            ArchiGraph checks for updates on launch and every 4 hours.
            Updates download in the background and apply on restart.
          </p>
        </div>
      </Container>
    </div>
  );
}
